export default "__VITE_ASSET__BZ4UB0TE__"